export const STATE_DELIMITER = '.';
export const TARGETLESS_KEY = '';
export const NULL_EVENT = '';
export const STATE_IDENTIFIER = '#';
export const WILDCARD = '*';
export const XSTATE_INIT = 'xstate.init';
export const XSTATE_ERROR = 'xstate.error';
export const XSTATE_STOP = 'xstate.stop';
